import React, { Fragment } from 'react';
import { styled } from '@compiled/react';

import { useBooleanFeatureFlag } from '@confluence/session-data';

// ViewPageHeader is 72px (37 content + 25px top padding + 10 px bottom padding)
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Placeholder = styled.div({
	minHeight: '72px',
});

// We can't export Placeholder directly because styled.div will render children
export const ContentHeaderPlaceholder = () => {
	const isPageHeaderFixed = useBooleanFeatureFlag('confluence.frontend.fixed-page-header');

	return isPageHeaderFixed ? <Fragment /> : <Placeholder />;
};
